<template>
  <div class="form-row" style="width: 100%;text-align: left;overflow: hidden">
    <div class="col-6" style="height: 50px;padding-left: 20px;cursor: pointer"  @click="gohome">
      <img src="../../assets/Home_images1.png" style="height: 100%;display: inline-block">
      <p class="top-text" style="margin-left: 10px;">VIDEO TRACKING SOFTWARE</p>
    </div>
    <div class="col-6" style="height: 50px;text-align: right">
<!--      <p class="top-text" style="margin-right: 10px;">You’re the {{ visited }} visiting this website.</p>-->
<!--      <img src="../../assets/cibr-blue.png" style="height: 62px"/>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "v-nav",
  data : function(){
    return {
      visited : 0
    }
  },
  beforeMount() {
    var that = this;
    this.$axios.post("/getAllVisited").then(function (res){
      console.log(res);
      that.visited = res.data.total;
    });
  },
  methods : {
    gohome : function (){
      this.$router.push("home");
    },
  }
}
</script>

<style scoped>

</style>